import {
  ingestionConstants,
  alertConstants,
  userConstants,
} from "../constants";
import { ingestionService } from "../services";

export const ingestionActions = {
  scrape,
  render,
  dispatch_ocr,
  retrieve_ocr,
  getIngestionRunDetail,
  classifyDealJacket,
};

function scrape(ingestionRequest) {
  return (dispatch) => {
    dispatch(ingestionAlert("initiating scrape request"));
    dispatch(request(ingestionRequest));

    ingestionService.scrape(ingestionRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(success(response));
        dispatch(clearAlert());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function request(ingestionRequest) {
    return {
      type: ingestionConstants.INGESTION_SCRAPE_REQUEST,
      ingestionRequest,
    };
  }
  function ingestionAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(response) {
    return { type: ingestionConstants.INGESTION_SCRAPE_SUCCESS, response };
  }
  function failure(error) {
    return { type: ingestionConstants.INGESTION_SCRAPE_FAILURE, error };
  }
}

function render(ingestionRequest) {
  return (dispatch) => {
    dispatch(ingestionAlert("initiating render request"));
    dispatch(request(ingestionRequest));

    ingestionService.render(ingestionRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(success(response));
        dispatch(clearAlert());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function request(ingestionRequest) {
    return {
      type: ingestionConstants.INGESTION_RENDER_REQUEST,
      ingestionRequest,
    };
  }
  function ingestionAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(response) {
    return { type: ingestionConstants.INGESTION_RENDER_SUCCESS, response };
  }
  function failure(error) {
    return { type: ingestionConstants.INGESTION_RENDER_FAILURE, error };
  }
}

function dispatch_ocr(ingestionRequest) {
  return (dispatch) => {
    dispatch(ingestionAlert("initiating dispatch request"));
    dispatch(request(ingestionRequest));

    ingestionService.dispatch_ocr(ingestionRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(success(response));
        dispatch(clearAlert());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function request(ingestionRequest) {
    return {
      type: ingestionConstants.INGESTION_DISPATCH_REQUEST,
      ingestionRequest,
    };
  }
  function ingestionAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(response) {
    return { type: ingestionConstants.INGESTION_DISPATCH_SUCCESS, response };
  }
  function failure(error) {
    return { type: ingestionConstants.INGESTION_DISPATCH_FAILURE, error };
  }
}

function retrieve_ocr(ingestionRequest) {
  return (dispatch) => {
    dispatch(ingestionAlert("initiating retrieve request"));
    dispatch(request(ingestionRequest));

    ingestionService.retrieve_ocr(ingestionRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(success(response));
        dispatch(clearAlert());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function request(ingestionRequest) {
    return {
      type: ingestionConstants.INGESTION_RETRIEVE_REQUEST,
      ingestionRequest,
    };
  }
  function ingestionAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(response) {
    return { type: ingestionConstants.INGESTION_RETRIEVE_SUCCESS, response };
  }
  function failure(error) {
    return { type: ingestionConstants.INGESTION_RETRIEVE_FAILURE, error };
  }
}

function getIngestionRunDetail(run_id) {
  return (dispatch) => {
    dispatch(ingestionAlert("fetching ingestion run detail"));
    dispatch(request(run_id));

    ingestionService.getIngestionRunDetail(run_id).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(success(response));
        dispatch(clearAlert());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function request(run_id) {
    return { type: ingestionConstants.INGESTION_DETAIL_REQUEST, run_id };
  }
  function ingestionAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(response) {
    return { type: ingestionConstants.INGESTION_DETAIL_SUCCESS, response };
  }
  function failure(error) {
    return { type: ingestionConstants.INGESTION_DETAIL_FAILURE, error };
  }
}

function classifyDealJacket(dealjacket_id) {
  return (dispatch) => {
    dispatch(ingestionAlert("classifying deal jacket..."));
    dispatch(request(dealjacket_id));

    ingestionService.classifyDealJacket(dealjacket_id).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(success(response));
        dispatch(clearAlert());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function request(run_id) {
    return {
      type: ingestionConstants.INGESTION_CLASSIFY_REQUEST,
      dealjacket_id,
    };
  }
  function ingestionAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(response) {
    return { type: ingestionConstants.INGESTION_CLASSIFY_SUCCESS, response };
  }
  function failure(error) {
    return { type: ingestionConstants.INGESTION_CLASSIFY_FAILURE, error };
  }
}
